import React from 'react';
import { LeadsListPage } from './LeadsListPage';

export function ConvertedListPage() {
  return <LeadsListPage defaultStatus="CONVERTED" />;
}
